export default {
  name: 'WeibyTabs',
  props: {
    classes: {
      default: 'ma-0 pa-0',
      type: [String, Array, Object],
    },
    tabs: {
      default: () => ([]),
      type: Array,
    },
    value: {
      default: 0,
      type: Number,
    },
  },
  methods: {
    setTab(tabIndex) {
      this.$emit('input', tabIndex);
    },
  },
};
